import { Typography } from '@material-ui/core'

export const Label = ({ children, fontFamily = 'PlusJakarta Text' }) => (
  <Typography
    variant="h6"
    color="textSecondary"
    style={{ opacity: 0.65, fontFamily }}
  >
    {children}
  </Typography>
)

export const Value = ({ variant = 'h4', children }) => (
  <Typography variant={variant}>{children}</Typography>
)
